import BasicLoadable from "@ovrsea/ovrlib/components/Loadable/BasicLoadable";

export const LoadableAtlasHotkeys = BasicLoadable({
  loader: () => import("./AtlasHotkeys"),
  loading: null,
});
